import {
  FETCH_COMPLETE,
  FETCH_CONFIG_INIT,
  SET_CONFIG,
  SET_APP_CONFIG,
  RESET_APP_CONFIG,
  SET_BILLING_DEFAULTS,
  SET_BILLING_ALL,
  SET_SYSTEM_PARAMETER,
} from "./types";

const initialState = {
  configs: {
    plan_check_days: "",
    plan_eligibility_days: "",
  },
  appConfig: {
    plan_check_days: "",
    plan_eligibility_days: "",
  },
  billing_defaults: {
    default_trail_days: "",
  },
  isDataLoading: false,
  disable_plan_eligible: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_CONFIG:
      return {
        ...state,
        configs: action.payload,
        appConfig: action.payload,
        isDataLoading: false,
      };
    case SET_BILLING_ALL:
      return {
        ...state,
        billing_defaults: action.payload,
        isDataLoading: false,
      };
    case FETCH_CONFIG_INIT:
      return { ...state, isDataLoading: true };
    case FETCH_COMPLETE:
      return { ...state, isDataLoading: false };
    case SET_APP_CONFIG:
      return {
        ...state,
        appConfig: {
          ...state.appConfig,
          [action.payload.name]: action.payload.value,
        },
      };
    case SET_BILLING_DEFAULTS:
      return {
        ...state,
        billing_defaults: {
          ...state.billing_defaults,
          [action.payload.name]: action.payload.value,
        },
      };
    case RESET_APP_CONFIG:
      return { ...state, appConfig: state.configs };
    case SET_SYSTEM_PARAMETER:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
